<h1>Sign in</h1>
<button (click)="loginWithGoogle()">Continue with Google</button>
